<section class="rh">
  <header class="rh__header">
    <h3 class="rh__title">
      <i class="fa-solid fa-clock-rotate-left rh__title-icon" aria-hidden="true"></i>
      {{ 'REVIEW_QUEUE.HISTORY_TITLE' | translate }}
    </h3>
  </header>

  @if (loading) {
    <p class="rh__loading">
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      {{ 'REVIEW_QUEUE.HISTORY_LOADING' | translate }}
    </p>
  } @else if (errored) {
    <app-error-state
      titleKey="REVIEW_QUEUE.HISTORY_ERROR_TITLE"
      messageKey="REVIEW_QUEUE.HISTORY_ERROR_MESSAGE"
      (retry)="retry.emit()"
    />
  } @else if (reviews.length === 0) {
    <app-empty-state
      icon="clock-rotate-left"
      titleKey="REVIEW_QUEUE.HISTORY_EMPTY_TITLE"
      messageKey="REVIEW_QUEUE.HISTORY_EMPTY_MESSAGE"
    />
  } @else {
    <ol class="rh__list">
      @for (review of reviews; track review.id) {
        <li
          class="rh__item"
          [class.rh__item--approved]="review.decision === 'approved'"
          [class.rh__item--rejected]="review.decision === 'rejected'"
        >
          <div class="rh__item-head">
            <span class="rh__decision">
              @if (review.decision === 'approved') {
                <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
                {{ 'REVIEW_QUEUE.DECISION_APPROVED' | translate }}
              } @else {
                <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
                {{ 'REVIEW_QUEUE.DECISION_REJECTED' | translate }}
              }
            </span>
            <time class="rh__date" [attr.datetime]="review.reviewedAt">
              {{ review.reviewedAt | date: 'dd/MM/yyyy HH:mm' }}
            </time>
          </div>

          <p class="rh__reviewer">
            <i class="fa-regular fa-user" aria-hidden="true"></i>
            {{ review.reviewerName }}
          </p>

          @if (review.comment) {
            <p class="rh__comment">{{ review.comment }}</p>
          } @else {
            <p class="rh__no-comment">
              {{ 'REVIEW_QUEUE.HISTORY_NO_COMMENT' | translate }}
            </p>
          }
        </li>
      }
    </ol>
  }
</section>
